import { render, staticRenderFns } from "./TransactionPreview.vue?vue&type=template&id=89e91e4a&scoped=true&"
import script from "./TransactionPreview.vue?vue&type=script&lang=js&"
export * from "./TransactionPreview.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPreview.vue?vue&type=style&index=0&id=89e91e4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e91e4a",
  null
  
)

export default component.exports